export const DOMAIN_MOVE_STORAGE_KEY = "domainMoveVisits";

interface DomainMoveVisits {
  visits: number;
  lastShownVisit: number;
}

export default function recordDomainMoveVisit(
  hostname = window.location.hostname
): boolean {
  if (hostname !== "valheim.cooking" && hostname !== "www.valheim.cooking") {
    return false;
  }

  let visits = 0;
  let lastShownVisit = 0;

  try {
    const stored: Partial<DomainMoveVisits> | null = JSON.parse(
      window.localStorage.getItem(DOMAIN_MOVE_STORAGE_KEY) || "null"
    );
    if (
      stored &&
      typeof stored.visits === "number" &&
      Number.isSafeInteger(stored.visits) &&
      stored.visits >= 0 &&
      stored.visits < Number.MAX_SAFE_INTEGER &&
      typeof stored.lastShownVisit === "number" &&
      Number.isSafeInteger(stored.lastShownVisit) &&
      stored.lastShownVisit >= 0 &&
      stored.lastShownVisit <= stored.visits
    ) {
      visits = stored.visits;
      lastShownVisit = stored.lastShownVisit;
    }
  } catch {
    // Missing or inaccessible storage is treated as a first visit.
  }

  visits += 1;
  const showNotice = (visits - 1) % 10 === 0;
  try {
    window.localStorage.setItem(
      DOMAIN_MOVE_STORAGE_KEY,
      JSON.stringify({
        visits,
        lastShownVisit: showNotice ? visits : lastShownVisit,
      })
    );
  } catch {
    // The notice still works when storage is disabled or full.
  }

  return showNotice;
}
